import React, { useEffect } from 'react'
import { ItemProps } from '@/components/Form/types'

import Form from '@/components/Form'
import items from './../forms/preview'
import createPreview from './createPreview'



export default function FontPreviewForm(props: ItemProps) {

	const formRef = React.useRef<any>(null)
	const [preview, setPreview] = React.useState<string | null>(null)



	const createImagePreview = async (font:File, text:string) => {
		const img = await createPreview(font, text)
		const url = img ? URL.createObjectURL(img) : null

		setPreview(url)
		props?.onChange?.("preview", img)
	}



	const handleChange = async (data: any) => {
		if (data?.previewStyle?.data?.file?.data) {
			createImagePreview(data?.previewStyle?.data?.file?.data, props?.formData?.fontFamily || "Font")
		} else {
			setPreview(null)
			props?.onChange?.("preview", null)
		}
		props?.onChange?.("previewStyle", data?.previewStyle?.value)

	}



	useEffect(() => {
		if (!preview && props.formData?.preview && props.formData?.previewStyle) {
			formRef.current.updateValue("previewText", props.formData?.fontFamily || "")
			formRef.current.updateValue("previewStyle", props.formData?.previewStyle)
			createImagePreview(props.formData?.previewStyle?.data?.file?.data, props?.formData?.fontFamily || "Font" )
		}

	}, [props.formData])



	useEffect(() => {
		const data = formRef.current?.getData() || {}
		handleChange(data)

	}, [props.formData.fontFamily])



	useEffect(() => {
		const list = props.formData?.fontStyle?.map((item:any) => ({
			label: item.name,
			value: item.id,
			data: item
		})) || []
		formRef.current.updateForm("previewStyle", "list", list)

	}, [props.formData?.fontStyle])




	return (
		<div>
			<div className={"grid grid-cols-12 gap-md"} >
				<Form
					ref={formRef}
					items={items}
					onChange={handleChange}
				/>
				{preview ?
					<div className={"col-span-6 h-[44px] flex justify-center items-center "}>
						<img src={preview} alt="preview" className={"h-[44px] object-contain border border-r-gray-100 rounded-md"} />
					</div>
					: null
				}
			</div>

		</div>
	)
}